<template>
  <g>
    <path
      d="M3 8.00018C3 8.55018 3.45 9.00018 4 9.00018C4.55 9.00018 5 8.55018 5 8.00018V6.00018H7C7.55 6.00018 8 5.55018 8 5.00018C8 4.45018 7.55 4.00018 7 4.00018H5V2.00018C5 1.45018 4.55 1.00018 4 1.00018C3.45 1.00018 3 1.45018 3 2.00018V4.00018H1C0.45 4.00018 0 4.45018 0 5.00018C0 5.55018 0.45 6.00018 1 6.00018H3V8.00018Z"
    />
    <path
      d="M13 17.0002C14.6569 17.0002 16 15.657 16 14.0002C16 12.3433 14.6569 11.0002 13 11.0002C11.3431 11.0002 10 12.3433 10 14.0002C10 15.657 11.3431 17.0002 13 17.0002Z"
    />
    <path
      d="M21 6.00018H17.83L16.59 4.65018C16.22 4.24018 15.68 4.00018 15.12 4.00018H8.72C8.89 4.30018 9 4.63018 9 5.00018C9 6.10018 8.1 7.00018 7 7.00018H6V8.00018C6 9.10018 5.1 10.0002 4 10.0002C3.63 10.0002 3.3 9.89018 3 9.72018V20.0002C3 21.1002 3.9 22.0002 5 22.0002H21C22.1 22.0002 23 21.1002 23 20.0002V8.00018C23 6.90018 22.1 6.00018 21 6.00018ZM13 19.0002C10.24 19.0002 8 16.7602 8 14.0002C8 11.2402 10.24 9.00018 13 9.00018C15.76 9.00018 18 11.2402 18 14.0002C18 16.7602 15.76 19.0002 13 19.0002Z"
    />
  </g>
</template>
